import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box, FormControl, FormControlLabel, Grid, Typography, Divider, RadioGroup, Radio,
  Button, Dialog, DialogContent, IconButton, DialogActions, CircularProgress, Collapse
} from '@material-ui/core';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import CustomMessagePoper from './custom-message-popover';
import { makeStyles } from '@material-ui/core';
import { useTranslate, useDataProvider } from 'react-admin';
import Field from '../CustomizedUIs/CustomTextFiled';
import CustomTextField from '../CustomizedUIs/CustomTextFieldWithFontSize';
import GreenSwitch from '../CustomizedUIs/GreenSwitch';
import DateTimePicker from '../common/date-time-picker';
import { FONT_SIZE, FONT_SIZE_LABEL, getTemplateInterval, SCHEDULE_TYPE } from '../utils';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import { Alert } from '@material-ui/lab';
import SelectBoxScheduleTemplate from '../common/select-box-schedule-template';

// Icons
import { Close } from '@material-ui/icons';
import SelectBoxInterval from '../common/select-box-interval';
import TextButton from '../CustomizedUIs/TextButton';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    minHeight: '90vh',
    maxHeight: '90vh',
    maxWidth: '620px',
    backgroundColor: theme.palette.background.default
  },
  dialogContent: {
    padding: '8px 40px'
  },
  list: {
    height: 255,
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
  dialogCloseBtn: {
    // backgroundColor: theme.palette.common.white,
    marginLeft: 7,
    width: "25px",
    height: "25px",
    borderRadius: "10px",
    border: "solid 2px #e5f1f8",
    backgroundColor: " #ffffff",

  },
  dialogPaper: {
    minHeight: '90vh',
    maxHeight: '90vh',
    maxWidth: '650px',
    backgroundColor: theme.palette.background.default
  },
  boxBoder: {
    borderBottom: '1px solid',
    borderRight: '1px solid',
    borderBottomColor: theme.palette.grey['200'],
    borderRightColor: theme.palette.grey['200'],
  },
  input: {
    backgroundColor: 'white',
    borderRadius: '2px',
    "&:hover": {
      backgroundColor: 'white'
    },
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.85,
    letterSpacing: ' 0.13px',
    color: '#88898c',
  },
  inputMulti: {
    width: 525,
    borderRadius: '2px',
  },
  inputPopper: {
    alignSelf: 'flex-end',
    position: 'absolute',
    right: '16px',
    top: '20px'
  },
  send: {
    marginRight: '30px',
    width: '138px',
    height: '36px',
  },
  dialogActions: {
    paddingLeft: 32,
    paddingRight: 35,
    bottom: 0,
    right: 0,
  },
  divider: {
    marginTop: '14px'
  },
  buttonFontSize: {
    marginLeft: '5px',
    marginTop: '5px',
    minHeight: '24px',
    minWidth: '30px',
    width: '22px',
    height: '24px',
    borderRadius: 3
  },
  buttonFontSizeInactive: {
    backgroundColor: '#f3f7fa'
  },
  switchText: {
    whiteSpace: 'nowrap',
    fontFamily: "UniviaPro-Bold",
    fontSize: "9px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.22,
    letterSpacing: " 0.36px",
    color: "#4f5064",
  },
  borderSearch: {
    borderRadius: "8.1px",
    border: "solid 0.8px #f1f2f4",
    backgroundColor: "#f7f7f7",

  },
  textSearch: {
    fontFamily: "UniviaPro-Book",
    fontSize: "11px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#88898c",
  },
  iconSearch: {
    border: "solid 0px #b4b5bd",
  },
  clusterText: {
    fontFamily: 'UniviaPro',
    fontSize: '11px',
    fontWeight: 'normal',
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 2.18,
    letterSpacing: "0.11px",
    color: "#4f5064",
  },
  btnClose: {
    fontFamily: " UniviaPro-Bold",
    fontSize: "10px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.4px",
    color: "#4f5064",
  },
  Title: {
    fontFamily: "UniviaPro-Medium",
    fontSize: "18px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.2,
    letterSpacing: "normal",
    color: "#4f5064",
    paddingBottom: "30px",
    marginTop: -10
  },
  titleRadio: {
    fontFamily: "UniviaPro-Medium",
    fontSize: "11px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.2,
    letterSpacing: "normal",
    color: "#4f5064",
  },
  TextDateTime: {
    fontFamily: "UniviaPro",
    fontSize: "13px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.85,
    letterSpacing: " 0.13px",
    color: "#4f5064",
  },
  titleDateTime: {
    fontFamily: " UniviaPro",
    fontSize: "11px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.36,
    letterSpacing: "normal",
    color: "#88898c",
  },
  TitileDyslexieFont: {
    fontFamily: "UniviaPro-Bold",
    fontSize: "9px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.22,
    letterSpacing: " 0.36px",
    color: "4f5064",
  },

  btnSave: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: ' 11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.44px',
    color: theme.palette.primary.main,
  },
  btnSend: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: ' 11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.44px',
    color: '#ffffff',
  },
}));

let dialogContent
function DialogEditTemplate({ open, onClose, template }) {
  const classes = useStyles();
  const translate = useTranslate();
  const dataProvider = useDataProvider();

  // STATE REGION
  const [name, setName] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [fontSize, setFontSize] = useState(FONT_SIZE_LABEL.MEDIUM);
  const [isDyslexieEnable, setDyslexieEnable] = useState(false);
  const [valuePriority, setValuePriority] = useState(0);
  const [valueMessageType, setValueMessageType] = useState(0);
  const [valueScheduleRadio, setValueScheduleRadio] = useState(0);
  const [valueExpirationRadio, setValueExpirationRadio] = useState(0);
  const [dateSchedule, setDateSchedule] = useState(new Date());
  const [dateExpiration, setDateExpiration] = useState(new Date());
  const [anchorEl, setAnchorEl] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [selectedRecurrence, setSelectedRecurrence] = useState(null);
  const [selectedScheduleTemplate, setSelectedScheduleTemplate] = useState(null);
  const [listScheduleTemplate, setListScheduleTemplate] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [error, setError] = useState({
    name: {
      isError: false,
      message: ""
    },
    message: {
      isError: false,
      message: ""
    }
  });
  // END STATE REGION

  const textOnChange = prop => (e) => {
    switch (prop) {
      case 'name':
        setName(e.target.value)
        break;
      case 'subject':
        setSubject(e.target.value)
        break;
      case 'message':
        setMessage(e.target.value)
        break;
    }
    validate(prop, e.target.value)
  }

  const validate = (prop, value) => {
    if (value.length === 0)
      setError({
        ...error, [prop]: value.length === 0 ? {
          isError: true, message: translate('pos.messages.required')
        } : {
            isError: false, message: ''
          }
      })
    else {
      setError({
        ...error, [prop]: {
          isError: false, message: ''
        }
      })
    }
  }

  const handleClickOpenPoper = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePoper = () => {
    setAnchorEl(null);
  };

  const onSubmit = () => {
    if (valueScheduleRadio === 1 && new Date(dateSchedule) < Date.now()) {
      setErrorMsg(translate(`pos.common.scheduleExpired`))
      dialogContent.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      autoHideErrorMessage()
    }
    else {
      if (valueExpirationRadio !== 0 && new Date(dateExpiration) < Date.now()) {
        setErrorMsg(translate(`pos.messages.errorExpiration`));
        dialogContent.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
        autoHideErrorMessage();
      }
      else {
        setSubmitting(true);
        const schedule = valueScheduleRadio === 1 ? dateSchedule.getTime() : -1;
        const expiration = valueExpirationRadio === 0 ? 0 : dateExpiration.getTime();
        const data = {
          name,
          subject,
          message,
          fontSize,
          dyslexie: isDyslexieEnable,
          priorityType: valuePriority,
          messageType: valueMessageType,
          scheduleType: valueScheduleRadio,
          interval: valueScheduleRadio === 1 ? (selectedRecurrence ? selectedRecurrence.name : 'None') : 'None',
          schedule,
          expiration
        };
        switch (valueScheduleRadio) {
          case SCHEDULE_TYPE.IMMEDIATELY:
            data.schedule = 0;
            data.scheduleTemplate = null;
            break;
          case SCHEDULE_TYPE.OTHER:
            data.schedule = dateSchedule.getTime();
            data.scheduleTemplate = null;
            break;
          case SCHEDULE_TYPE.SCHEDULE_TEMPLATE:
            data.schedule = 0;
            data.scheduleTemplate = selectedScheduleTemplate.id;
            break;
        }

        dataProvider('UPDATE', 'message-template', {
          id: template.id,
          data
        }).then(res => {
          console.log('Update template success:', res);
          setSubmitting(false);
          onClose(true);
          clearState();
        }).catch(error => {
          // TODO: Should show error message
          console.error('Update template error:', error);
          setSubmitting(false);
        });
      }
    }
  }

  const clearState = () => {
    setName('');
    setSubject('');
    setMessage('');
    setFontSize(FONT_SIZE_LABEL.MEDIUM);
    setDyslexieEnable(false);
    setValuePriority(0);
    setValueMessageType(0);
    setValueScheduleRadio(0);
    setValueExpirationRadio(0);
    setSelectedRecurrence(null);
  }

  const close = () => {
    clearState();
    onClose();
  }

  const onChangeRecurrence = (value) => {
    setSelectedRecurrence(value)
  }

  const disableCreateButton = () => {
    if (name === '' || message === '') return true;
    return false;
  }

  const onEnter = () => {
    setName(template.name);
    setSubject(template.subject);
    setMessage(template.message);
    setFontSize(template.fontSize);
    setDyslexieEnable(template.dyslexie);
    setValuePriority(template.priorityType);
    setValueMessageType(template.messageType);
    setValueScheduleRadio(template.scheduleType);
    setSelectedRecurrence(getTemplateInterval(template.interval));

    if (template.scheduleType === 1) {
      setDateSchedule(new Date(template.schedule));
    }
    if (template.scheduleType === 2) {
      listScheduleTemplate.map(value => {
        if (value.id === template.scheduleTemplate)
          setSelectedScheduleTemplate(value)
      })
    }

    if (template.expiration === 0) {
      setValueExpirationRadio(0);
    } else {
      setValueExpirationRadio(1);
      setDateExpiration(new Date(template.expiration));
    }
  }

  const autoHideErrorMessage = () => {
    setTimeout(() => {
      setErrorMsg('');
    }, 6000);
  }

  const getListScheduleTemplates = () => {
    dataProvider('GET_LIST', "schedule-template", {
      filter: {
      },
      pagination: {},
      sort: { field: 'name', order: 'ASC' },
    }).then(({ data }) => {
      setListScheduleTemplate(data)
    }).catch(error => {
      console.error('getListScheduleTemplates:', error);
    });
  }

  const onChangeScheduleTemplate = (value) => {
    setSelectedScheduleTemplate(value);
    if (value.scheduleMessages.length > 0) {
      const firstTemplate = value.scheduleMessages[0];
      setSubject(firstTemplate.subject)
      setMessage(firstTemplate.message)
    }
  }

  useEffect(() => {
    getListScheduleTemplates();
  }, []);

  const openPoper = anchorEl !== null;
  return (
    <Dialog open={open} fullWidth scroll='paper' classes={{ paper: classes.dialogPaper }} onEnter={onEnter}>
      <Box mx={5} mt={3} ref={node => dialogContent = node}>
        <Box display='flex' justifyContent='flex-end' alignItems='center'>
          <Typography className={classes.btnClose}>{translate(`pos.user.close`)}</Typography>
            <CloseButton onClick={onClose} />
        </Box>
        <Typography className={classes.Title}>{translate(`resources.messages.editTemplate`)}</Typography>
      </Box>
      <div>
        <DialogContent className={classes.dialogContent}>
          <Collapse in={errorMsg.length > 0}>
            <Alert severity="error">{errorMsg}</Alert>
          </Collapse>
          <Box mx={2.5}>
            <Field
              onBlur={() => {
                validate('name', name)
              }}
              required
              id="filled-basic"
              label={translate(`resources.customers.fields.name`)}
              error={error.name.message != "" && error.name.isError}
              helperText={error.name.message}
              value={name}
              onChange={textOnChange('name')}
              style={{ width: 525 }}
              endDom={<CustomPoper
                open={openPoper}
                anchorEl={anchorEl}
                handleClick={handleClickOpenPoper}
                handleClose={handleClosePoper}
                title={translate(`resources.customers.fields.name`)}
                content={translate(`pos.messages.nameTemplate`)}
                icon={<b>?</b>}
              />}
            />
          </Box>

          <Box mt={4} mx={2.5}>
            <Field
              required
              id="filled-basic"
              label={translate(`pos.messages.subject`)}
              value={subject}
              onChange={textOnChange('subject')}
              style={{ width: 525 }}
              endDom={<CustomPoper
                open={openPoper}
                anchorEl={anchorEl}
                handleClick={handleClickOpenPoper}
                handleClose={handleClosePoper}
                title={translate(`pos.messages.subject`)}
                content={translate(`pos.messages.constentSubject`)}
                icon={<b>?</b>}
              />}
            />
          </Box>

          <Box mt={4} mx={2.5}>
            <FormControl component="fieldset">
              <Grid container spacing={1} alignItems="center" >
                <Grid item>
                  <Typography className={classes.titleRadio}>{translate(`resources.messages.priority`)}</Typography>
                </Grid>
                <Grid item>
                  <CustomMessagePoper
                    open={openPoper}
                    anchorEl={anchorEl}
                    handleClick={handleClickOpenPoper}
                    handleClose={handleClosePoper}
                    title={translate(`resources.messages.priority`)}
                    content={translate(`resources.messages.prioritymessage`)}
                    icon={<b>?</b>}
                  />
                </Grid>
              </Grid>
              <RadioGroup row aria-label="edit-priority" name="edit-priority" value={valuePriority} onChange={e => setValuePriority(parseInt(e.target.value))}>
                <FormControlLabel value={0} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.critical`)} />
                <FormControlLabel value={1} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.Normal`)} style={{ marginLeft: '92px' }} />
              </RadioGroup>
            </FormControl>
          </Box>
          <Divider className={classes.divider} />

          <Box mt={2.5} mx={2.5}>
            <FormControl component="fieldset">
              <Grid container spacing={1} alignItems="center" >
                <Grid item>
                  <Typography className={classes.titleRadio}> {translate(`resources.messages.messagetype`)}</Typography>
                </Grid>
                <Grid item>
                  <CustomMessagePoper
                    open={openPoper}
                    anchorEl={anchorEl}
                    handleClick={handleClickOpenPoper}
                    handleClose={handleClosePoper}
                    title={translate(`pos.messages.type`)}
                    content={translate(`pos.messages.constentType`)}
                    icon={<b>?</b>}
                  />
                </Grid>
              </Grid>
              <RadioGroup row aria-label="edit-message-type" name="edit-message-type" value={valueMessageType} onChange={e => setValueMessageType(parseInt(e.target.value))}>
                <FormControlLabel value={0} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.popup`)} />
                <FormControlLabel value={1} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.Notification`)} style={{ marginLeft: '90px' }} />
              </RadioGroup>
            </FormControl>
          </Box>
          <Divider className={classes.divider} />

          <Box mt={2.5} mx={2.5}>
            <FormControl component="fieldset">
              <Grid container spacing={1} alignItems="center" >
                <Grid item>
                  <Typography className={classes.titleRadio} color="textPrimary" >{translate(`resources.messages.Schedule`)}</Typography>
                </Grid>
                <Grid item>
                  <CustomMessagePoper
                    open={openPoper}
                    anchorEl={anchorEl}
                    handleClick={handleClickOpenPoper}
                    handleClose={handleClosePoper}
                    title={translate(`pos.messages.schedule`)}
                    content={translate(`pos.messages.constentSchedule`)}
                    icon={<b>?</b>}
                  />
                </Grid>
              </Grid>
              <RadioGroup row aria-label="edit-schedule" name="edit-schedule" value={valueScheduleRadio} onChange={e => setValueScheduleRadio(parseInt(e.target.value))}>
                <FormControlLabel value={0} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.Immediately`)} />
                <FormControlLabel value={1} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.Other`)} style={{ marginLeft: '63px' }} />
                <FormControlLabel value={2} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.ScheduleTemplate`)} style={{ marginLeft: '70px' }} />
              </RadioGroup>
            </FormControl>
          </Box>
          <SelectBoxInterval
            open={valueScheduleRadio === 1}
            recurrence={selectedRecurrence}
            onSelect={onChangeRecurrence}
          />
          <DateTimePicker
            open={valueScheduleRadio === 1}
            date={dateSchedule}
            setDate={setDateSchedule}
            style='message'
            minDate={new Date()}
            title={translate(`resources.reviews.fields.date`)}
          />
          <SelectBoxScheduleTemplate
            open={valueScheduleRadio === SCHEDULE_TYPE.SCHEDULE_TEMPLATE}
            scheduleTemplate={selectedScheduleTemplate}
            onSelect={onChangeScheduleTemplate}
          />
          <Divider className={classes.divider} />
          <Box mt={2.5} mx={2.5}>
            <FormControl component="fieldset">
              <Grid container spacing={1} alignItems="center" >
                <Grid item>
                  <Typography className={classes.titleRadio}>{translate(`pos.messages.expiration`)}</Typography>
                </Grid>
                <Grid item>
                  <CustomMessagePoper
                    open={openPoper}
                    anchorEl={anchorEl}
                    handleClick={handleClickOpenPoper}
                    handleClose={handleClosePoper}
                    title={translate(`pos.messages.expiration`)}
                    content={translate(`pos.messages.constentExpiration`)}
                    icon={<b>?</b>}
                  />
                </Grid>
              </Grid>
              <RadioGroup row aria-label="edit-expiration" name="edit-expiration" value={valueExpirationRadio} onChange={e => setValueExpirationRadio(parseInt(e.target.value))}>
                <FormControlLabel value={0} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label="None" />
                <FormControlLabel value={1} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label="Day/time" style={{ marginLeft: '100px' }} />
              </RadioGroup>
            </FormControl>
          </Box>
          <DateTimePicker
            open={valueExpirationRadio === 1}
            date={dateExpiration}
            setDate={setDateExpiration}
            style='message'
            minDate={new Date()}
            title={translate(`resources.reviews.fields.date`)}
          />
          <Divider className={classes.divider} />

          <Box mt={4.9} mx={2.5}>
            <CustomTextField
              onBlur={() => {
                validate('message', message)
              }}
              className={classes.inputMulti}
              id="textfield-message"
              multiline
              rows={4}
              value={message}
              onChange={textOnChange('message')}
              fontSize={fontSize}
              setFontSize={setFontSize}
              placeholder={`${translate(`pos.messages.placeholder`)} *`}
              error={error.message.message != "" && error.message.isError}
              helperText={error.message.message}
              isDyslexieEnable={isDyslexieEnable}
              getFontSize={fontSize}
              endDom={
                <Box>
                  <Box className={classes.inputPopper}>
                    <CustomPoper
                      open={openPoper}
                      anchorEl={anchorEl}
                      handleClick={handleClickOpenPoper}
                      handleClose={handleClosePoper}
                      title={translate(`pos.messages.constent`)}
                      content={translate(`pos.messages.constentContent`)}
                      icon={<b>?</b>}
                    />
                  </Box>
                </Box>
              }
            />
          </Box>
          <Box mt={3} mx={2.5} display='flex' alignItems='center'>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="flex-start">
              <Grid item alignItems="center" >
              </Grid>
              <Grid item>
                <Box display='flex' borderRadius={4} bgcolor='background.paper' py={0.4} pr={1} pl={2} alignItems='center'>
                  <Box flexGrow={1}>
                    <Typography className={classes.TitileDyslexieFont} style={{ marginRight: 23 }}>{translate(`pos.messages.dyslexieFont`).toUpperCase()}</Typography>
                  </Box>
                  <GreenSwitch checked={isDyslexieEnable} onChange={() => setDyslexieEnable(!isDyslexieEnable)}
                    size='small' style={{ color: 'white' }}></GreenSwitch>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </div>
      <DialogActions className={classes.dialogActions}>
        <TextButton mr={2} style={{ marginTop: "1em" }} onClick={close} />
          
        <Button
          disabled={submitting || disableCreateButton()}
          variant="contained"
          className={classes.send}
          size="large"
          color="primary"
          onClick={onSubmit}
        >
          {
            submitting ? (
              <CircularProgress
                size={25}
                thickness={2}
                color='inherit'
              />
            ) : <Typography className={classes.btnSend}>{translate('pos.common.save')}</Typography>
          }
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DialogEditTemplate.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  template: PropTypes.object,
};

export default DialogEditTemplate;
